import type { SubHeaderMenuItemType } from '#base/core/types/SubHeaderMenuItemType';

const items: SubHeaderMenuItemType[] = [];

items.push({
	icon: 'fa-envelope',
	text: 'Contact',
	to: {
		title: 'Contact opnemen met Fit Hier',
		url: '/contact',
		newTab: false,
	},
});

items.push({
	icon: 'fa-arrow-right-from-bracket',
	text: 'App Login',
	to: {
		title: 'Inloggen Fit Hier app',
		url: 'https://fysio-hier.trainin.app/',
		newTab: true,
	},
});

export default items;
